import gql from 'graphql-tag';

export const SKIP_WORK_ITEMS_MUTATION = gql`
  mutation SkipWorkItemsMutation($workItemIds: [String!]!, $isFlexibleSpec: Boolean) {
    success: skipWorkItems(workItemIds: $workItemIds, isFlexibleSpec: $isFlexibleSpec)
  }
`;
